import React from 'react'
import Main from '../Main'

function MailValidator() {
    return (
        <>
            <Main active="service">
                <div className="main">
                    <section>
                        <div className="container section-title">
                            <h2>Mail Validator</h2>
                        </div>
                    </section>
                </div>
            </Main>
        </>
    )
}

export default MailValidator
